import z from 'zod';
export const REMOVAL_TAGS_CAP = 5_000;
const sourceId = z
    .string()
    .min(1)
    .max(200)
    .refine((value) => value.trim() === value && !value.includes('\0'));
const printed = z
    .string()
    .max(200)
    .refine((value) => value.trim().length > 0 && !value.includes('\0'));
export const removalTagEvidenceSchema = z.object({
    documentId: sourceId,
    reconstructedDocumentId: sourceId,
    pageId: sourceId,
    serialNumber: printed.optional(),
    partNumber: printed.optional(),
    kind: z.enum(['serviceable', 'unserviceable', 'removal', 'external-repair']).optional(),
    date: z.iso.date().optional(),
    dateRaw: printed.optional(),
    workOrder: printed.optional(),
});
export const removalTagsReadyWebhookSchema = z.object({
    type: z.literal('removal-tags-ready'),
    projectId: sourceId,
    generation: z.number().int().min(1).max(2_147_483_647),
    generatedAt: z.iso.datetime(),
    tags: z.array(removalTagEvidenceSchema).max(REMOVAL_TAGS_CAP),
});
//# sourceMappingURL=removal-tags-ready.webhook.js.map